import { ACTIONS } from 'actions/lists'
import { transformGoalTagsIntoPillarsGoals } from '@wellbeingxltd/fe-lib/helpers'

const initialState = {
    automationType: [],
    goalTags: [],
    pillarsGoals: {},
    filterTagsByPillar: [],
    type: [],
    typeOfEngagement: [],

    getGoalsListLoading: false,
    getGoalsListError: null,
}

const listReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.GET_LIST.SUCCESS:
            return { ...state, [action.payload.field]: action.payload.list }

        case ACTIONS.GET_GOALS_LIST.START:
            return { ...state, getGoalsListLoading: true }
        case ACTIONS.GET_GOALS_LIST.SUCCESS:
            const goalTags = action.goalTags
            const pillarsGoals = transformGoalTagsIntoPillarsGoals({ goalTags })
            return {
                ...state,
                goalTags,
                getGoalsListLoading: false,
                getGoalsListError: null,
                pillarsGoals,
            }
        case ACTIONS.GET_GOALS_LIST.FAILURE:
            return { ...state, getGoalsListLoading: false, getGoalsListError: action.error }

        default:
            return state
    }
}

export default listReducer
